import React, { useRef, useState, useEffect } from 'react'
import { useAuthDataContext } from '../../../../../_providers/Auth'
import Api from '../../../../../_helpers/Api'
import editIcon from '../../../../../assets/img/icons/edit-yellow.png'
import Modal from './modals/ReservationType'
import Skeleton from 'react-loading-skeleton'
import Options from './ReservationTypesOptions'
import NoDataFound from '../../../../partials/NoDataFound'
import { trans } from '../../../../../_providers/Translation'
import { useHistory, useLocation } from 'react-router'

function ReservationTypes(props) {

    const auth = useAuthDataContext()

    const location = useLocation()
    const history = useHistory()

    const searchParams = new URLSearchParams(location.search)

    const modalRef = useRef(null)
    const searchTimeoutRef = useRef(null)

    const [state, setState] = useState({
        loading: true,
        data: [],
        update: false,
        filters: {
            name: '',
        },
    })

    useEffect(() => {
        setState(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                name: searchParams.get('name') || '',
            },
            update: new Date().getTime()
        }))
    }, [location.search])

    useEffect(() => {
        if (state.setFilter) {
            searchParams.set('page', state.page)

            Object.entries(state.filters).map(filter => {
                searchParams.set(filter[0], filter[1])
            })

            history.push('?' + searchParams.toString())
        }
    }, [state.setFilter])

    useEffect(() => {
        if (state.update) {
            loadSettings()
        }
    }, [state.update])

    const loadSettings = () => {
        setState(prev => ({
            ...prev,
            loading: true,
        }))

        Api.get('reservations/types?partner_id=' + auth.partnerId() + '&name=' + state.filters.name)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data
                }))
            }).catch(err => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const handleAdd = () => {
        let modal = modalRef.current

        modal.open()

        modal.onSave(data => {
            setState(prev => ({
                ...prev,
                data: prev.data.concat(data)
            }))

            if (typeof props.handleRefresh === 'function') {
                props.handleRefresh()
            }
        })

    }

    const handleEdit = id => {
        let modal = modalRef.current

        modal.edit(id)

        modal.onSave(data => {
            handleUpdate()

            if (typeof props.handleRefresh === 'function') {
                props.handleRefresh()
            }
        })

    }

    const handleUpdate = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    const handleDelete = id => {
        Api.post('reservations/types/delete', {
            id: id
        }).then(res => {
            if (res.data.success) {
                handleUpdate()
            }
        })
    }

    function handleSearch(e) {
        const { name, value } = e.target

        clearTimeout(searchTimeoutRef.current)

        setState(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                [name]: value
            },
        }))

        searchTimeoutRef.current = setTimeout(() => {
            setState(prev => ({
                ...prev,
                page: 1,
                setFilter: new Date().getTime()
            }))
        }, 300)
    }
    return (
        <div style={{ width: '100%' }}>
            <Modal
                ref={modalRef}
            />

            <div className="head">
                <h3
                    style={{
                        marginBottom: 0
                    }}
                >{trans('headings.reservationTypes')}</h3>

                <button
                    className="button button-add button-small"
                    onClick={handleAdd}
                >
                    {trans('buttons.add')}
                </button>
            </div>
            <div className='filter-standard'>
                <div className="col" data-id="4">
                    <input
                        id="search"
                        type="search"
                        name="name"
                        value={state.filters.name}
                        onChange={handleSearch}
                        placeholder={trans('labels.search')}
                    />
                </div>
            </div>
            <hr />

            {state.loading
                ?
                <Skeleton height={35} count={10} />
                :
                <>
                    {state.data.length === 0
                        ?
                        <NoDataFound />
                        :
                        <div className="table-scroller">
                            <table className="settings">
                                <thead>
                                    <tr>
                                        <th>
                                            {trans('labels.name')}
                                        </th>
                                        <th>
                                            {trans('labels.reservationTypeExecTime')}
                                        </th>
                                        <th className="options center">
                                            {trans('labels.options')}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {state.data.map(t =>
                                        <tr key={t.id}>
                                            <td>
                                                {t.name}
                                            </td>
                                            <td>
                                                {t.minutes}
                                            </td>
                                            <td className="options center">
                                                <Options
                                                    id={t.id}
                                                    handleEdit={handleEdit}
                                                    handleDelete={handleDelete}
                                                />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    }
                </>
            }
        </div>
    )

}

export default ReservationTypes